import {
  SchedulePayload,
  StatusKandidatPayload,
} from "../../../../models/Kandidat";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";
import { fetchAllKandidatKey } from "../../queries/Kandidat/useFetchAllKandidat";
import getQueryClient from "../../queryClient";

export async function editStatusKandidat(data: StatusKandidatPayload) {
  const res = await ApiClient.put(`/EditStatusKandidat`, data);
  return res.data;
}

export const useEditStatusKandidat = mutationWrapper(editStatusKandidat, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(fetchAllKandidatKey);
  },
});
